// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AazMapController from "./aaz_map_controller"
application.register("aaz-map", AazMapController)

import AazMapEditController from "./aaz_map_edit_controller"
application.register("aaz-map-edit", AazMapEditController)

import AdditionalApprovalController from "./additional_approval_controller"
application.register("additional-approval", AdditionalApprovalController)

import AiracVersionSelectController from "./airac_version_select_controller"
application.register("airac-version-select", AiracVersionSelectController)

import AirportZoneMapController from "./airport_zone_map_controller"
application.register("airport-zone-map", AirportZoneMapController)

import AlertNotificationController from "./alert_notification_controller"
application.register("alert-notification", AlertNotificationController)

import AssessmentSiteInfoController from "./assessment_site_info_controller"
application.register("assessment-site-info", AssessmentSiteInfoController)

import AssessorOrgInfoController from "./assessor_org_info_controller"
application.register("assessor-org-info", AssessorOrgInfoController)

import AutoModalController from "./auto_modal_controller"
application.register("auto-modal", AutoModalController)

import AutosaveController from "./autosave_controller"
application.register("autosave", AutosaveController)

import CableTestController from "./cable_test_controller"
application.register("cable-test", CableTestController)

import CheckoutController from "./checkout_controller"
application.register("checkout", CheckoutController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CustomMapLayerController from "./custom_map_layer_controller"
application.register("custom-map-layer", CustomMapLayerController)

import CustomMapLayersOverviewController from "./custom_map_layers_overview_controller"
application.register("custom-map-layers-overview", CustomMapLayersOverviewController)

import DashboardFilterController from "./dashboard_filter_controller"
application.register("dashboard-filter", DashboardFilterController)

import DashboardFlightActivationController from "./dashboard_flight_activation_controller"
application.register("dashboard-flight-activation", DashboardFlightActivationController)

import DashboardMapController from "./dashboard_map_controller"
application.register("dashboard-map", DashboardMapController)

import DeleteAttachmentController from "./delete_attachment_controller"
application.register("delete-attachment", DeleteAttachmentController)

import DisableFormController from "./disable_form_controller"
application.register("disable-form", DisableFormController)

import FileListController from "./file_list_controller"
application.register("file-list", FileListController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import FlatpickrDashboardController from "./flatpickr_dashboard_controller"
application.register("flatpickr-dashboard", FlatpickrDashboardController)

import FlightActivationController from "./flight_activation_controller"
application.register("flight-activation", FlightActivationController)

import FormMapController from "./form_map_controller"
application.register("form-map", FormMapController)

import GeojsonFeatureEditorController from "./geojson_feature_editor_controller"
application.register("geojson-feature-editor", GeojsonFeatureEditorController)

import GeojsonLivePreviewController from "./geojson_live_preview_controller"
application.register("geojson-live-preview", GeojsonLivePreviewController)

import KmlUploadController from "./kml_upload_controller"
application.register("kml-upload", KmlUploadController)

import LayerMapPreviewController from "./layer_map_preview_controller"
application.register("layer-map-preview", LayerMapPreviewController)

import MessageController from "./message_controller"
application.register("message", MessageController)

import ModalTriggerController from "./modal_trigger_controller"
application.register("modal-trigger", ModalTriggerController)

import NotamAccordionController from "./notam_accordion_controller"
application.register("notam-accordion", NotamAccordionController)

import NotamController from "./notam_controller"
application.register("notam", NotamController)

import TabPersistenceController from "./tab_persistence_controller"
application.register("tab-persistence", TabPersistenceController)

import TemplatePreviewController from "./template_preview_controller"
application.register("template-preview", TemplatePreviewController)

import TrainingUserSelectorController from "./training_user_selector_controller"
application.register("training-user-selector", TrainingUserSelectorController)

import UploadFlightAreaController from "./upload_flight_area_controller"
application.register("upload-flight-area", UploadFlightAreaController)

import UserSelectorController from "./user_selector_controller"
application.register("user-selector", UserSelectorController)

import VatCalculatorController from "./vat_calculator_controller"
application.register("vat-calculator", VatCalculatorController)
